import { useQuery } from "@tanstack/react-query";
import i18next from "i18next";
import { getUserRoles } from "../../api/apiRoles";

export const useGetUserRoles = (userId) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["user-roles", userId, i18next.language],
        queryFn: () => getUserRoles(userId),
        enabled: !!userId,
    });

    const root = data?.data || {};
    const roles =
        Array.isArray(root.roles) ? root.roles
        : Array.isArray(root) ? root
        : [];
    const effectivePermissions =
        Array.isArray(root.effective_permissions) ? root.effective_permissions : [];

    return { roles, effectivePermissions, isLoading, error, refetch };
};
